import { Component, OnInit, Renderer2 } from '@angular/core';

@Component({
  selector: 'app-mobile-ns-fifty',
  templateUrl: './mobile-ns-fifty.component.html',
  styleUrls: ['./mobile-ns-fifty.component.scss']
})
export class MobileNsFiftyComponent implements OnInit {

  constructor(private renderer: Renderer2) {}

  ngOnInit(): void {
    this.loadScript('https://adcdn.nightlife.net/afe755b2.js');
  }

  loadScript(src: string): void {
    const script = this.renderer.createElement('script');
    script.src = src;
    script.async = true;
    this.renderer.appendChild(document.body, script);
  }


}
